export function price(price: number) {
    return price + ' €';
}